import React,{createContext,useContext,useEffect,useRef} from 'react';
import {ScrollView,type LayoutChangeEvent,type NativeScrollEvent,type NativeSyntheticEvent} from 'react-native';

export const ScrollPositionContext=createContext<{positions:Map<string,number>;page:string}|null>(null);

/** Navigation-local memory: no persistent personal data, and no writes from the
 * initial zero-offset event while a returning page is still being laid out. */
export function useScrollPosition(externalRef?:React.RefObject<ScrollView|null>){
 const context=useContext(ScrollPositionContext),ownRef=useRef<ScrollView>(null),ref=externalRef??ownRef;
 const initial=useRef(context?.positions.get(context.page)??0),restoring=useRef(initial.current>0);
 const viewport=useRef(0),content=useRef(0),frame=useRef(0);
 useEffect(()=>()=>cancelAnimationFrame(frame.current),[]);
 const restore=()=>{
  if(!restoring.current||!viewport.current||!content.current)return;
  cancelAnimationFrame(frame.current);
  frame.current=requestAnimationFrame(()=>{if(!restoring.current)return;const y=Math.min(initial.current,Math.max(0,content.current-viewport.current));ref.current?.scrollTo({y,animated:false});});
 };
 return {ref,contentOffset:{x:0,y:initial.current},scrollEventThrottle:16,
  onLayout:(e:LayoutChangeEvent)=>{viewport.current=e.nativeEvent.layout.height;restore();},
  onContentSizeChange:(_width:number,height:number)=>{content.current=height;restore();},
  onScrollBeginDrag:()=>{restoring.current=false;cancelAnimationFrame(frame.current);},
  onScroll:(e:NativeSyntheticEvent<NativeScrollEvent>)=>{const y=Math.max(0,e.nativeEvent.contentOffset.y);if(restoring.current){if(Math.abs(y-initial.current)>1)return;restoring.current=false;}context?.positions.set(context.page,y);}
 };
}
